<template>
  <div class="hero-wrapper pt-100 pb-100">
    <div class="container flex items-center justify-between mb-flex-wrap">
      <div class="maxw-685 wp-100">
        <h1 class="mb-20 fw-900 fs-52 lh-52 white mb-fs-28 mb-lh-28"><slot name="title"></slot></h1>
        <div class="mb-mb-30 fw-700 fs-16 lh-16 white"><slot name="sub-title"></slot></div>
      </div>
      <div><slot name="button"></slot></div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@include phone {
  .hero-wrapper {
    background-position: center;
    background-size: cover;
    height: 340px;
  }
}
</style>
